import script from "./LKNavigationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LKNavigationPanel.vue?vue&type=script&setup=true&lang=js"

import "./LKNavigationPanel.vue?vue&type=style&index=0&id=6b527fa9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b527fa9"]])

export default __exports__